export const moduleName = 'admin/signup-codes'

export type SignupCodeStatus = 'active' | 'deactivated'

export type NormalisedSignupCode = {
  code: string
  organisation: {
    id: string
    name: string
    logo: string
  }
  startDate: Date
  timesUsed: number
  status: SignupCodeStatus
}

export type NormalisedSignupCodesResponse = {
  codes: NormalisedSignupCode[]
}
